import dynamic from 'next/dynamic';
import { SearchResultsBlockProps } from './SearchResultsBlock';

export const DynamicSearchResultsBlock = dynamic<SearchResultsBlockProps>(() =>
    import('./SearchResultsBlock').then(md => md.SearchResultsBlock),
);
